import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import setTitle from 'vue-set-title'
import { i18n } from '../helpers/lang'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/lottery',
    name: 'Lottery',
    component: () => import(/* webpackChunkName: "lottery" */ '../views/Lottery.vue')
  },
  {
    path: '/lottery-history',
    name: 'Lottery',
    component: () => import(/* webpackChunkName: "lotteryHistory" */ '../views/LotteryHistory.vue')
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      title: i18n.t('MyCredits')
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

Vue.use(setTitle, router, i18n.t('MyCredits'))

export default router
